import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setUsers, setUsersPagination } from '../slices/usersSlice';
import { store } from '../store';

export const getUsers = async ({
  page,
  searchText,
  searchEmail,
  role,
  status,
  loading,
  isDispatch = true,
} = {}) => {
  const res = await handleGetRequest(URI.users, null, {
    toast: false,
    loading,
    params: { page, searchText, searchEmail, role, status },
  });
  if (res?.ack && isDispatch) {
    store.dispatch(setUsers(res.users));
    store.dispatch(setUsersPagination(res.pagination));
  }
  return res;
};

export const getUser = async ({ id, loading = true }) => {
  const res = await handleGetRequest(URI.user_by_id(id), null, {
    params: { id },
    toast: false,
    loading,
  });
  return res;
};

export const addUserSettings = async (payload) => {
  const res = await handlePostRequest(URI.user_settings, payload, { toast: false });
  return res;
};

export const updateUser = async (body) => {
  const res = await handlePutRequest(URI.user, body);
  if (res?.ack) getUsers();
  return res;
};

export const deleteUser = async (body) => {
  const res = await handleDeleteRequest(URI.user, body);
  if (res?.ack) getUsers();
  return res;
};

export const addUser = async (body) => {
  const res = await handlePostRequest(URI.user, body);
  if (res?.ack) getUsers();
  return res;
};
